import { ScrollReveal } from "@/components/base/ScrollAnimations";
import { associationPartners, strategicPartners } from "@/mocks/homeData";

export default function EcosystemPartners() {
  return (
    <section id="partners" className="bg-white py-16 md:py-24">
      <div className="w-full px-4 md:px-8 lg:px-12">
        {/* Association Partners */}
        <div className="max-w-5xl mx-auto mb-12 md:mb-16">
          <ScrollReveal>
            <div className="text-center max-w-3xl mx-auto mb-8 md:mb-10">
              <div className="inline-flex items-center gap-2 px-3 py-1.5 rounded-md bg-tie-teal/10 mb-4 md:mb-5">
                <span className="text-xs font-semibold text-tie-teal uppercase tracking-wider">
                  / In Association
                </span>
              </div>
              <h2 className="font-serif text-2xl md:text-3xl lg:text-4xl font-bold text-tie-text-primary">
                Sector-Wide Reach & Credibility
              </h2>
              <p className="mt-3 md:mt-4 text-base md:text-lg text-tie-text-secondary">
                TIE is honoured to be backed by Bangladesh's leading textile industry associations who share our mission to build innovation capability across the ecosystem.
              </p>
            </div>
          </ScrollReveal>

          <div className="grid md:grid-cols-2 gap-6 md:gap-8">
            {associationPartners.map((partner, index) => (
              <ScrollReveal key={partner.shortName} delay={index * 150}>
                <div className="bg-tie-grey-light rounded-2xl p-6 md:p-8 border border-tie-grey-dark hover:border-tie-teal/30 hover:shadow-lg transition-all duration-300">
                  <div className="inline-flex items-center gap-2 px-3 py-1.5 rounded-full bg-tie-navy text-white text-xs font-semibold mb-5 md:mb-6">
                    <i className="ri-shield-star-line" />
                    In Association Partner
                  </div>

                  <div className="h-20 md:h-24 flex items-center justify-start mb-5 md:mb-6">
                    <img
                      src={partner.logo}
                      alt={partner.name}
                      className="max-h-full max-w-[180px] md:max-w-[220px] w-auto object-contain"
                    />
                  </div>

                  <h3 className="text-lg md:text-xl font-bold text-tie-text-primary mb-2">
                    {partner.name}
                  </h3>

                  <div className="mt-4 md:mt-5 space-y-2">
                    {partner.focus.map((item) => (
                      <div
                        key={item}
                        className="flex items-center gap-2.5 text-sm text-tie-text-secondary"
                      >
                        <span className="w-1.5 h-1.5 rounded-full bg-tie-teal shrink-0" />
                        {item}
                      </div>
                    ))}
                  </div>
                </div>
              </ScrollReveal>
            ))}
          </div>
        </div>

        {/* Strategic Partners */}
        <div className="max-w-5xl mx-auto">
          <ScrollReveal delay={200}>
            <div className="text-center max-w-3xl mx-auto mb-8 md:mb-10">
              <div className="inline-flex items-center gap-2 px-3 py-1.5 rounded-md bg-tie-teal/10 mb-4 md:mb-5">
                <span className="text-xs font-semibold text-tie-teal uppercase tracking-wider">
                  / Strategic Partners
                </span>
              </div>
              <h2 className="font-serif text-2xl md:text-3xl lg:text-4xl font-bold text-tie-text-primary">
                Early Adopters & Co-Developers
              </h2>
              <p className="mt-3 md:mt-4 text-base md:text-lg text-tie-text-secondary">
                Leading factory groups that serve as demonstration sites, pilot partners, and innovation champions across Bangladesh's textile sector.
              </p>
            </div>
          </ScrollReveal>

          <div className="grid grid-cols-2 sm:grid-cols-3 lg:grid-cols-5 gap-4 md:gap-6">
            {strategicPartners.map((partner, index) => (
              <ScrollReveal key={partner.name} delay={index * 80}>
                <div className="bg-tie-grey-light rounded-xl p-4 md:p-6 border border-tie-grey-dark hover:border-tie-teal/30 hover:shadow-md transition-all duration-300 flex flex-col items-center justify-center gap-3 h-full">
                  <div className="h-14 md:h-16 flex items-center justify-center w-full">
                  {partner.logo ? (
                    <img
                      src={partner.logo}
                      alt={partner.name}
                      className="max-h-full max-w-full w-auto object-contain"
                    />
                  ) : (
                    <div className="w-12 h-12 md:w-14 md:h-14 rounded-lg bg-tie-navy/10 flex items-center justify-center">
                      <span className="text-sm md:text-base font-bold text-tie-navy">
                        {partner.name.split(' ').map(w => w[0]).join('').substring(0, 2).toUpperCase()}
                      </span>
                    </div>
                  )}
                  </div>
                  <p className="text-xs md:text-sm font-semibold text-tie-text-primary text-center leading-snug">
                    {partner.name}
                  </p>
                </div>
              </ScrollReveal>
            ))}
          </div>
        </div>
      </div>
    </section>
  );
}